import type { StaffOperationsApi } from "@lafayette/api-client";
import { createContext, type ReactNode, useContext } from "react";

// What the Operations page needs from outside: the typed API client and the clock. The admin app supplies the real ones
// (`admin-runtime.ts`); a test supplies fakes.

export type OperationsRuntime = Readonly<{
  api: StaffOperationsApi;
  now: () => Date;
}>;

const RuntimeContext = createContext<OperationsRuntime | null>(null);

export function OperationsRuntimeProvider({
  value,
  children,
}: Readonly<{ value: OperationsRuntime; children: ReactNode }>) {
  return <RuntimeContext.Provider value={value}>{children}</RuntimeContext.Provider>;
}

export function useOperationsRuntime(): OperationsRuntime {
  const runtime = useContext(RuntimeContext);
  if (runtime === null) throw new Error("The operations page needs an OperationsRuntimeProvider.");
  return runtime;
}
